<template>
    <aside class="sidebar sidebar-icons-right sidebar-icons-boxed sidebar-expand-lg">
      <bounce class="my-200" v-if="loading"></bounce>
      <nav class="scroll sidebar-navigation" v-else>

        <div class="sidebar-profile pt-30">
          <img class="avatar avatar-xxl" v-if="profileDetails.avatar == null" src="../../assets/static/img/avatar.jpg">
          <img class="avatar avatar-xxl" v-else :src="profileDetails.avatars[0].secure_url">
          <div class="profile-info">
            <h4 class="text-capitalize">{{userDetails.firstname}} {{userDetails.lastname}}</h4>
          </div>
        </div>

        <ul class="menu menu-lg menu-bordery">
          <li class="menu-item">
            <router-link tag="a" to="/dashboard" class="menu-link">
               <span class="icon ion-ios-home"></span>
              <span class="title">
                Dashboard
              </span> 
            </router-link>
          </li>

          <li class="menu-item">
              <router-link tag="a" to="/profile" class="menu-link">
                <span class="icon ion-person"></span>
                <span class="title">
                    Profile
                </span> 
            </router-link>
          </li>

          <li class="menu-item">
              <router-link tag="a" to="/listeners" class="menu-link">
               <span class="icon ion-ios-people"></span>
              <span class="title">Listeners</span> 
            </router-link>
          </li>

          <li class="menu-item">
              <router-link tag="a" to="/chat" class="menu-link">
               <span class="icon ion-chatboxes"></span>
              <span class="title">Chat Room</span>
            </router-link>
          </li>

          <li class="menu-item">
            <a class="menu-link" href="#" @click="logOut">
              <span class="icon ion-log-out"></span>
              <span class="title">Log Out</span>
              <circle-spin v-if="log_load" class="float-right"></circle-spin>
            </a>
          </li>
        </ul>
      </nav>

    </aside>
</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
  mixins: [allMixins],
  data() {
    return {
      loading: true,
      log_load: false,
      userDetails: {},
      profileDetails: {}
    }
  },
  methods: {
    logOut() {
      this.log_load = true
      axios.post('/users/signout')
      .then(res => {
        this.log_load = false
        localStorage.clear()
        this.$notify({
          group: 'response',
          type: 'success',
          text: 'Successfully Logged Out',
          duration: 1500,
        })
        setTimeout(() => {
            this.$router.push('/')
          }, 2000)       
      })
      .catch(err => {
          this.log_load = false
          this.$notify({
          group: 'response',
          type: 'error',
          text:  `${err.response.data.message}`,
          duration: 2500,
        })
      }) 
    }
  },
  mounted() {
    this.loading = true
    let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
    axios.get(`users/find/${details.id}`)
    .then(res => {
        this.userDetails = res.data.user_details
        this.profileDetails = res.data.seeker[0]
        this.loading = false
    })
    .catch(err => {
          this.loading = false
          // console.log(err)
          this.$notify({
          group: 'response',
          type: 'error',
          text: 'Error fetching user. Log in again',
          duration: 2500,
        });
        setTimeout(() => {
          this.$router.push('/')
          }, 3000)
    })
  }
}
</script>
